module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [(_vm.variation.cnovaAttributes && _vm.variation.cnovaAttributes.some(function (attribute) { return attribute.name !== 'Selecione'; })) ? _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])]) : _vm._e(), _vm._v(" "), (_vm.variation.cnovaAttributes) ? _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.variation.cnovaAttributes), function(attribute, index) {
    return (attribute.name !== 'Selecione') ? _c('form-group', {
      key: attribute.id,
      attrs: {
        "label": attribute.name,
        "columns": 3,
        "error": _vm.getError(attribute.id, _vm.variation.sku),
        "required": attribute.required
      }
    }, [(attribute.select) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((attribute.values), function(option) {
      return _c('option', {
        domProps: {
          "value": option.text
        }
      }, [_vm._v(_vm._s(option.text))])
    })], 2) : (attribute.multiselect) ? _c('multiselect', {
      attrs: {
        "track-by": "text",
        "label": "text",
        "options": attribute.values,
        "multiple": true,
        "selectLabel": "Clique",
        "selectedLabel": "Selecionado",
        "placeholder": "Selecione a opção"
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    })], 1) : _vm._e()
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-caa4a0e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/cnova/provide/Variation.vue
// module id = 3434
// module chunks = 0